import { buildClientAuditMeta } from '../clientPresence/buildClientPresencePayload';

export type SupportTicketContextPayload = {
  app_version: string;
  platform: string;
  build?: string;
  branch_label: string;
  branch_id: string | null;
};

/**
 * Metadatos para `support_tickets.context` (JSONB), alineado con el cuerpo del mail
 * que antes armaba `openFeedbackMail` en Perfil.
 */
export async function buildSupportTicketContext(params: {
  branchName?: string | null;
  branchId: string | null;
}): Promise<SupportTicketContextPayload> {
  const client = await buildClientAuditMeta();
  const branchLine = params.branchName
    ? `${params.branchName}${params.branchId != null ? ` (${params.branchId})` : ''}`
    : params.branchId != null
      ? params.branchId
      : 'sin sucursal';

  return {
    app_version: client.app_version,
    platform: client.platform,
    ...(client.build != null && client.build !== '' ? { build: client.build } : {}),
    branch_label: branchLine,
    branch_id: params.branchId,
  };
}
